/* ================================================================
   WM 2026 TIPPSPIEL – wm2026.js
   Everybody in the House
   ================================================================ */

/* ── CONFIG ──────────────────────────────────────────────────── */
const CFG = {
  SCRIPT_URL:   'https://script.google.com/macros/s/AKfycbyPCe6oQTLORchprtOi47YB3iJLLNuadtTOjcbPPjI2QVukBMmAYX2XQmIrSVWvDVELUQ/exec',
  OPENLIGA_URL: 'https://api.openligadb.de/getmatchdata/wm26/2026/',
  PTS_EXACT:    3,
  PTS_TEND:     1,
  PAGE_SIZE:    12,   // match cards per "load more" page
  OPENLIGA_ROUNDS: [1,2,3,4,5,6,7,8,9,10,11,12,13], // group stage + KO rounds
};

/* ── ALL 104 WM 2026 GAMES ───────────────────────────────────── */
/*
  Fields:
    id   – unique game ID
    d    – date (dd.mm.yyyy)
    t    – kickoff time CEST
    t1   – team 1 (German name)
    f1   – flag country code (flagcdn.com)
    t2   – team 2
    f2   – flag code
    g    – group letter (A-L) or stage code
    rnd  – round label (German)
    s    – status: open | locked | live | finished | pending
    s1   – score team1 ('' = not played)
    s2   – score team2
    b    – boost text ('' = none)
    q1   – odds team1 (display only)
    q2   – odds team2
*/
const SCHEDULE = [
  // Gruppe A
  {id:'G001',d:'11.06.2026',t:'21:00',t1:'Mexiko',f1:'mx',t2:'Südafrika',f2:'za',g:'A',rnd:'Gruppe A',s:'open',s1:'',s2:'',b:'',q1:'1.85',q2:'3.70'},
  {id:'G002',d:'12.06.2026',t:'02:00',t1:'Südkorea',f1:'kr',t2:'Tschechien',f2:'cz',g:'A',rnd:'Gruppe A',s:'open',s1:'',s2:'',b:'',q1:'2.10',q2:'3.40'},
  {id:'G003',d:'18.06.2026',t:'18:00',t1:'Tschechien',f1:'cz',t2:'Südafrika',f2:'za',g:'A',rnd:'Gruppe A',s:'open',s1:'',s2:'',b:'',q1:'2.00',q2:'3.60'},
  {id:'G004',d:'19.06.2026',t:'03:00',t1:'Mexiko',f1:'mx',t2:'Südkorea',f2:'kr',g:'A',rnd:'Gruppe A',s:'open',s1:'',s2:'',b:'',q1:'1.80',q2:'4.20'},
  {id:'G005',d:'25.06.2026',t:'03:00',t1:'Tschechien',f1:'cz',t2:'Mexiko',f2:'mx',g:'A',rnd:'Gruppe A',s:'open',s1:'',s2:'',b:'2× BOOST',q1:'3.20',q2:'2.20'},
  {id:'G006',d:'25.06.2026',t:'03:00',t1:'Südafrika',f1:'za',t2:'Südkorea',f2:'kr',g:'A',rnd:'Gruppe A',s:'open',s1:'',s2:'',b:'',q1:'3.40',q2:'2.10'},
  // Gruppe B
  {id:'G007',d:'12.06.2026',t:'21:00',t1:'Kanada',f1:'ca',t2:'Bosnien-Herzegowina',f2:'ba',g:'B',rnd:'Gruppe B',s:'open',s1:'',s2:'',b:'',q1:'1.95',q2:'3.80'},
  {id:'G008',d:'13.06.2026',t:'21:00',t1:'Katar',f1:'qa',t2:'Schweiz',f2:'ch',g:'B',rnd:'Gruppe B',s:'open',s1:'',s2:'',b:'',q1:'4.50',q2:'1.75'},
  {id:'G009',d:'18.06.2026',t:'21:00',t1:'Schweiz',f1:'ch',t2:'Bosnien-Herzegowina',f2:'ba',g:'B',rnd:'Gruppe B',s:'open',s1:'',s2:'',b:'',q1:'1.70',q2:'4.80'},
  {id:'G010',d:'19.06.2026',t:'00:00',t1:'Kanada',f1:'ca',t2:'Katar',f2:'qa',g:'B',rnd:'Gruppe B',s:'open',s1:'',s2:'',b:'',q1:'1.40',q2:'8.00'},
  {id:'G011',d:'24.06.2026',t:'21:00',t1:'Schweiz',f1:'ch',t2:'Kanada',f2:'ca',g:'B',rnd:'Gruppe B',s:'open',s1:'',s2:'',b:'2× BOOST',q1:'2.20',q2:'3.30'},
  {id:'G012',d:'24.06.2026',t:'21:00',t1:'Bosnien-Herzegowina',f1:'ba',t2:'Katar',f2:'qa',g:'B',rnd:'Gruppe B',s:'open',s1:'',s2:'',b:'',q1:'1.90',q2:'4.00'},
  // Gruppe C
  {id:'G013',d:'14.06.2026',t:'00:00',t1:'Brasilien',f1:'br',t2:'Marokko',f2:'ma',g:'C',rnd:'Gruppe C',s:'open',s1:'',s2:'',b:'🔥 TOP-SPIEL',q1:'1.55',q2:'5.50'},
  {id:'G014',d:'14.06.2026',t:'03:00',t1:'Haiti',f1:'ht',t2:'Schottland',f2:'gb-sct',g:'C',rnd:'Gruppe C',s:'open',s1:'',s2:'',b:'',q1:'4.20',q2:'1.90'},
  {id:'G015',d:'20.06.2026',t:'00:00',t1:'Schottland',f1:'gb-sct',t2:'Marokko',f2:'ma',g:'C',rnd:'Gruppe C',s:'open',s1:'',s2:'',b:'',q1:'3.20',q2:'2.30'},
  {id:'G016',d:'20.06.2026',t:'02:30',t1:'Brasilien',f1:'br',t2:'Haiti',f2:'ht',g:'C',rnd:'Gruppe C',s:'open',s1:'',s2:'',b:'',q1:'1.20',q2:'14.0'},
  {id:'G017',d:'25.06.2026',t:'00:00',t1:'Schottland',f1:'gb-sct',t2:'Brasilien',f2:'br',g:'C',rnd:'Gruppe C',s:'open',s1:'',s2:'',b:'2× BOOST',q1:'6.00',q2:'1.45'},
  {id:'G018',d:'25.06.2026',t:'00:00',t1:'Marokko',f1:'ma',t2:'Haiti',f2:'ht',g:'C',rnd:'Gruppe C',s:'open',s1:'',s2:'',b:'',q1:'1.35',q2:'9.00'},
  // Gruppe D
  {id:'G019',d:'13.06.2026',t:'03:00',t1:'USA',f1:'us',t2:'Paraguay',f2:'py',g:'D',rnd:'Gruppe D',s:'open',s1:'',s2:'',b:'',q1:'1.70',q2:'4.60'},
  {id:'G020',d:'14.06.2026',t:'06:00',t1:'Australien',f1:'au',t2:'Türkei',f2:'tr',g:'D',rnd:'Gruppe D',s:'open',s1:'',s2:'',b:'',q1:'2.80',q2:'2.65'},
  {id:'G021',d:'19.06.2026',t:'21:00',t1:'USA',f1:'us',t2:'Australien',f2:'au',g:'D',rnd:'Gruppe D',s:'open',s1:'',s2:'',b:'',q1:'1.60',q2:'5.50'},
  {id:'G022',d:'20.06.2026',t:'05:00',t1:'Türkei',f1:'tr',t2:'Paraguay',f2:'py',g:'D',rnd:'Gruppe D',s:'open',s1:'',s2:'',b:'',q1:'2.10',q2:'3.50'},
  {id:'G023',d:'26.06.2026',t:'04:00',t1:'Türkei',f1:'tr',t2:'USA',f2:'us',g:'D',rnd:'Gruppe D',s:'open',s1:'',s2:'',b:'2× BOOST',q1:'4.50',q2:'1.75'},
  {id:'G024',d:'26.06.2026',t:'04:00',t1:'Paraguay',f1:'py',t2:'Australien',f2:'au',g:'D',rnd:'Gruppe D',s:'open',s1:'',s2:'',b:'',q1:'2.60',q2:'2.80'},
  // Gruppe E
  {id:'G025',d:'14.06.2026',t:'19:00',t1:'Deutschland',f1:'de',t2:'Curaçao',f2:'cw',g:'E',rnd:'Gruppe E',s:'open',s1:'',s2:'',b:'',q1:'1.15',q2:'16.0'},
  {id:'G026',d:'15.06.2026',t:'01:00',t1:'Elfenbeinküste',f1:'ci',t2:'Ecuador',f2:'ec',g:'E',rnd:'Gruppe E',s:'open',s1:'',s2:'',b:'',q1:'2.20',q2:'3.30'},
  {id:'G027',d:'20.06.2026',t:'22:00',t1:'Deutschland',f1:'de',t2:'Elfenbeinküste',f2:'ci',g:'E',rnd:'Gruppe E',s:'open',s1:'',s2:'',b:'🔥 TOP-SPIEL',q1:'1.50',q2:'6.00'},
  {id:'G028',d:'21.06.2026',t:'02:00',t1:'Ecuador',f1:'ec',t2:'Curaçao',f2:'cw',g:'E',rnd:'Gruppe E',s:'open',s1:'',s2:'',b:'',q1:'1.45',q2:'7.50'},
  {id:'G029',d:'25.06.2026',t:'22:00',t1:'Curaçao',f1:'cw',t2:'Elfenbeinküste',f2:'ci',g:'E',rnd:'Gruppe E',s:'open',s1:'',s2:'',b:'',q1:'5.50',q2:'1.60'},
  {id:'G030',d:'25.06.2026',t:'22:00',t1:'Ecuador',f1:'ec',t2:'Deutschland',f2:'de',g:'E',rnd:'Gruppe E',s:'open',s1:'',s2:'',b:'2× BOOST',q1:'7.00',q2:'1.35'},
  // Gruppe F
  {id:'G031',d:'14.06.2026',t:'22:00',t1:'Niederlande',f1:'nl',t2:'Japan',f2:'jp',g:'F',rnd:'Gruppe F',s:'open',s1:'',s2:'',b:'',q1:'1.75',q2:'4.50'},
  {id:'G032',d:'15.06.2026',t:'04:00',t1:'Schweden',f1:'se',t2:'Tunesien',f2:'tn',g:'F',rnd:'Gruppe F',s:'open',s1:'',s2:'',b:'',q1:'1.80',q2:'4.20'},
  {id:'G033',d:'20.06.2026',t:'19:00',t1:'Niederlande',f1:'nl',t2:'Schweden',f2:'se',g:'F',rnd:'Gruppe F',s:'open',s1:'',s2:'',b:'',q1:'1.65',q2:'5.20'},
  {id:'G034',d:'21.06.2026',t:'06:00',t1:'Tunesien',f1:'tn',t2:'Japan',f2:'jp',g:'F',rnd:'Gruppe F',s:'open',s1:'',s2:'',b:'',q1:'2.90',q2:'2.55'},
  {id:'G035',d:'26.06.2026',t:'01:00',t1:'Japan',f1:'jp',t2:'Schweden',f2:'se',g:'F',rnd:'Gruppe F',s:'open',s1:'',s2:'',b:'2× BOOST',q1:'2.50',q2:'2.90'},
  {id:'G036',d:'26.06.2026',t:'01:00',t1:'Tunesien',f1:'tn',t2:'Niederlande',f2:'nl',g:'F',rnd:'Gruppe F',s:'open',s1:'',s2:'',b:'',q1:'5.50',q2:'1.60'},
  // Gruppe G
  {id:'G037',d:'15.06.2026',t:'21:00',t1:'Belgien',f1:'be',t2:'Ägypten',f2:'eg',g:'G',rnd:'Gruppe G',s:'open',s1:'',s2:'',b:'',q1:'1.70',q2:'4.80'},
  {id:'G038',d:'16.06.2026',t:'03:00',t1:'Iran',f1:'ir',t2:'Neuseeland',f2:'nz',g:'G',rnd:'Gruppe G',s:'open',s1:'',s2:'',b:'',q1:'2.00',q2:'3.80'},
  {id:'G039',d:'21.06.2026',t:'21:00',t1:'Belgien',f1:'be',t2:'Iran',f2:'ir',g:'G',rnd:'Gruppe G',s:'open',s1:'',s2:'',b:'',q1:'1.50',q2:'6.50'},
  {id:'G040',d:'22.06.2026',t:'03:00',t1:'Neuseeland',f1:'nz',t2:'Ägypten',f2:'eg',g:'G',rnd:'Gruppe G',s:'open',s1:'',s2:'',b:'',q1:'3.20',q2:'2.30'},
  {id:'G041',d:'27.06.2026',t:'05:00',t1:'Ägypten',f1:'eg',t2:'Iran',f2:'ir',g:'G',rnd:'Gruppe G',s:'open',s1:'',s2:'',b:'',q1:'2.80',q2:'2.65'},
  {id:'G042',d:'27.06.2026',t:'05:00',t1:'Neuseeland',f1:'nz',t2:'Belgien',f2:'be',g:'G',rnd:'Gruppe G',s:'open',s1:'',s2:'',b:'2× BOOST',q1:'8.00',q2:'1.30'},
  // Gruppe H
  {id:'G043',d:'15.06.2026',t:'18:00',t1:'Spanien',f1:'es',t2:'Kap Verde',f2:'cv',g:'H',rnd:'Gruppe H',s:'open',s1:'',s2:'',b:'',q1:'1.25',q2:'12.0'},
  {id:'G044',d:'16.06.2026',t:'00:00',t1:'Saudi-Arabien',f1:'sa',t2:'Uruguay',f2:'uy',g:'H',rnd:'Gruppe H',s:'open',s1:'',s2:'',b:'',q1:'2.60',q2:'2.85'},
  {id:'G045',d:'21.06.2026',t:'18:00',t1:'Spanien',f1:'es',t2:'Saudi-Arabien',f2:'sa',g:'H',rnd:'Gruppe H',s:'open',s1:'',s2:'',b:'',q1:'1.35',q2:'9.00'},
  {id:'G046',d:'22.06.2026',t:'00:00',t1:'Uruguay',f1:'uy',t2:'Kap Verde',f2:'cv',g:'H',rnd:'Gruppe H',s:'open',s1:'',s2:'',b:'',q1:'1.40',q2:'8.50'},
  {id:'G047',d:'27.06.2026',t:'04:00',t1:'Kap Verde',f1:'cv',t2:'Saudi-Arabien',f2:'sa',g:'H',rnd:'Gruppe H',s:'open',s1:'',s2:'',b:'',q1:'3.80',q2:'2.00'},
  {id:'G048',d:'27.06.2026',t:'02:00',t1:'Uruguay',f1:'uy',t2:'Spanien',f2:'es',g:'H',rnd:'Gruppe H',s:'open',s1:'',s2:'',b:'2× BOOST',q1:'5.50',q2:'1.55'},
  // Gruppe I
  {id:'G049',d:'16.06.2026',t:'21:00',t1:'Frankreich',f1:'fr',t2:'Senegal',f2:'sn',g:'I',rnd:'Gruppe I',s:'open',s1:'',s2:'',b:'🔥 TOP-SPIEL',q1:'1.60',q2:'5.50'},
  {id:'G050',d:'17.06.2026',t:'00:00',t1:'Irak',f1:'iq',t2:'Norwegen',f2:'no',g:'I',rnd:'Gruppe I',s:'open',s1:'',s2:'',b:'',q1:'3.50',q2:'2.10'},
  {id:'G051',d:'22.06.2026',t:'23:00',t1:'Frankreich',f1:'fr',t2:'Irak',f2:'iq',g:'I',rnd:'Gruppe I',s:'open',s1:'',s2:'',b:'',q1:'1.30',q2:'11.0'},
  {id:'G052',d:'23.06.2026',t:'02:00',t1:'Norwegen',f1:'no',t2:'Senegal',f2:'sn',g:'I',rnd:'Gruppe I',s:'open',s1:'',s2:'',b:'',q1:'2.20',q2:'3.30'},
  {id:'G053',d:'26.06.2026',t:'21:00',t1:'Norwegen',f1:'no',t2:'Frankreich',f2:'fr',g:'I',rnd:'Gruppe I',s:'open',s1:'',s2:'',b:'2× BOOST',q1:'6.00',q2:'1.50'},
  {id:'G054',d:'26.06.2026',t:'21:00',t1:'Senegal',f1:'sn',t2:'Irak',f2:'iq',g:'I',rnd:'Gruppe I',s:'open',s1:'',s2:'',b:'',q1:'1.90',q2:'4.00'},
  // Gruppe J
  {id:'G055',d:'17.06.2026',t:'03:00',t1:'Argentinien',f1:'ar',t2:'Algerien',f2:'dz',g:'J',rnd:'Gruppe J',s:'open',s1:'',s2:'',b:'🔥 TOP-SPIEL',q1:'1.55',q2:'6.00'},
  {id:'G056',d:'17.06.2026',t:'06:00',t1:'Österreich',f1:'at',t2:'Jordanien',f2:'jo',g:'J',rnd:'Gruppe J',s:'open',s1:'',s2:'',b:'',q1:'1.80',q2:'4.30'},
  {id:'G057',d:'22.06.2026',t:'19:00',t1:'Argentinien',f1:'ar',t2:'Österreich',f2:'at',g:'J',rnd:'Gruppe J',s:'open',s1:'',s2:'',b:'',q1:'1.65',q2:'5.20'},
  {id:'G058',d:'23.06.2026',t:'05:00',t1:'Jordanien',f1:'jo',t2:'Algerien',f2:'dz',g:'J',rnd:'Gruppe J',s:'open',s1:'',s2:'',b:'',q1:'3.10',q2:'2.40'},
  {id:'G059',d:'28.06.2026',t:'04:00',t1:'Algerien',f1:'dz',t2:'Österreich',f2:'at',g:'J',rnd:'Gruppe J',s:'open',s1:'',s2:'',b:'2× BOOST',q1:'2.90',q2:'2.55'},
  {id:'G060',d:'28.06.2026',t:'04:00',t1:'Jordanien',f1:'jo',t2:'Argentinien',f2:'ar',g:'J',rnd:'Gruppe J',s:'open',s1:'',s2:'',b:'',q1:'9.00',q2:'1.30'},
  // Gruppe K
  {id:'G061',d:'17.06.2026',t:'19:00',t1:'Portugal',f1:'pt',t2:'DR Kongo',f2:'cd',g:'K',rnd:'Gruppe K',s:'open',s1:'',s2:'',b:'',q1:'1.45',q2:'7.50'},
  {id:'G062',d:'18.06.2026',t:'04:00',t1:'Usbekistan',f1:'uz',t2:'Kolumbien',f2:'co',g:'K',rnd:'Gruppe K',s:'open',s1:'',s2:'',b:'',q1:'3.80',q2:'1.95'},
  {id:'G063',d:'23.06.2026',t:'19:00',t1:'Portugal',f1:'pt',t2:'Usbekistan',f2:'uz',g:'K',rnd:'Gruppe K',s:'open',s1:'',s2:'',b:'',q1:'1.25',q2:'12.0'},
  {id:'G064',d:'24.06.2026',t:'04:00',t1:'Kolumbien',f1:'co',t2:'DR Kongo',f2:'cd',g:'K',rnd:'Gruppe K',s:'open',s1:'',s2:'',b:'',q1:'1.75',q2:'4.50'},
  {id:'G065',d:'28.06.2026',t:'01:30',t1:'Kolumbien',f1:'co',t2:'Portugal',f2:'pt',g:'K',rnd:'Gruppe K',s:'open',s1:'',s2:'',b:'2× BOOST',q1:'4.00',q2:'1.85'},
  {id:'G066',d:'28.06.2026',t:'01:30',t1:'DR Kongo',f1:'cd',t2:'Usbekistan',f2:'uz',g:'K',rnd:'Gruppe K',s:'open',s1:'',s2:'',b:'',q1:'1.80',q2:'4.20'},
  // Gruppe L
  {id:'G067',d:'17.06.2026',t:'22:00',t1:'England',f1:'gb-eng',t2:'Kroatien',f2:'hr',g:'L',rnd:'Gruppe L',s:'open',s1:'',s2:'',b:'🔥 TOP-SPIEL',q1:'1.70',q2:'4.80'},
  {id:'G068',d:'18.06.2026',t:'01:00',t1:'Ghana',f1:'gh',t2:'Panama',f2:'pa',g:'L',rnd:'Gruppe L',s:'open',s1:'',s2:'',b:'',q1:'2.10',q2:'3.50'},
  {id:'G069',d:'23.06.2026',t:'22:00',t1:'England',f1:'gb-eng',t2:'Ghana',f2:'gh',g:'L',rnd:'Gruppe L',s:'open',s1:'',s2:'',b:'',q1:'1.40',q2:'8.50'},
  {id:'G070',d:'24.06.2026',t:'01:00',t1:'Panama',f1:'pa',t2:'Kroatien',f2:'hr',g:'L',rnd:'Gruppe L',s:'open',s1:'',s2:'',b:'',q1:'3.20',q2:'2.30'},
  {id:'G071',d:'27.06.2026',t:'23:00',t1:'Panama',f1:'pa',t2:'England',f2:'gb-eng',g:'L',rnd:'Gruppe L',s:'open',s1:'',s2:'',b:'2× BOOST',q1:'8.50',q2:'1.30'},
  {id:'G072',d:'27.06.2026',t:'23:00',t1:'Kroatien',f1:'hr',t2:'Ghana',f2:'gh',g:'L',rnd:'Gruppe L',s:'open',s1:'',s2:'',b:'',q1:'2.00',q2:'3.70'},
  // ── Runde der 32 ──
  {id:'R001',d:'28.06.2026',t:'21:00',t1:'Südafrika',f1:'za',t2:'Kanada',f2:'ca',g:'R32',rnd:'Runde der 32',s:'finished',s1:'0',s2:'1',b:'',q1:'',q2:''},
  {id:'R002',d:'29.06.2026',t:'22:30',t1:'Deutschland',f1:'de',t2:'Paraguay',f2:'py',g:'R32',rnd:'Runde der 32',s:'open',s1:'',s2:'',b:'🔥 TOP-SPIEL',q1:'',q2:''},
  {id:'R003',d:'30.06.2026',t:'03:00',t1:'Niederlande',f1:'nl',t2:'Marokko',f2:'ma',g:'R32',rnd:'Runde der 32',s:'open',s1:'',s2:'',b:'',q1:'',q2:''},
  {id:'R004',d:'29.06.2026',t:'19:00',t1:'Brasilien',f1:'br',t2:'Japan',f2:'jp',g:'R32',rnd:'Runde der 32',s:'open',s1:'',s2:'',b:'',q1:'',q2:''},
  {id:'R005',d:'30.06.2026',t:'23:00',t1:'Frankreich',f1:'fr',t2:'Schweden',f2:'se',g:'R32',rnd:'Runde der 32',s:'open',s1:'',s2:'',b:'',q1:'',q2:''},
  {id:'R006',d:'30.06.2026',t:'19:00',t1:'Elfenbeinküste',f1:'ci',t2:'Norwegen',f2:'no',g:'R32',rnd:'Runde der 32',s:'open',s1:'',s2:'',b:'',q1:'',q2:''},
  {id:'R007',d:'01.07.2026',t:'03:00',t1:'Mexiko',f1:'mx',t2:'Ecuador',f2:'ec',g:'R32',rnd:'Runde der 32',s:'open',s1:'',s2:'',b:'',q1:'',q2:''},
  {id:'R008',d:'01.07.2026',t:'18:00',t1:'England',f1:'gb-eng',t2:'DR Kongo',f2:'cd',g:'R32',rnd:'Runde der 32',s:'open',s1:'',s2:'',b:'',q1:'',q2:''},
  {id:'R009',d:'02.07.2026',t:'02:00',t1:'USA',f1:'us',t2:'Bosnien-Herzegowina',f2:'ba',g:'R32',rnd:'Runde der 32',s:'open',s1:'',s2:'',b:'',q1:'',q2:''},
  {id:'R010',d:'01.07.2026',t:'22:00',t1:'Belgien',f1:'be',t2:'Senegal',f2:'sn',g:'R32',rnd:'Runde der 32',s:'open',s1:'',s2:'',b:'',q1:'',q2:''},
  {id:'R011',d:'03.07.2026',t:'01:00',t1:'Portugal',f1:'pt',t2:'Kroatien',f2:'hr',g:'R32',rnd:'Runde der 32',s:'open',s1:'',s2:'',b:'',q1:'',q2:''},
  {id:'R012',d:'02.07.2026',t:'21:00',t1:'Spanien',f1:'es',t2:'Österreich',f2:'at',g:'R32',rnd:'Runde der 32',s:'open',s1:'',s2:'',b:'',q1:'',q2:''},
  {id:'R013',d:'03.07.2026',t:'05:00',t1:'Schweiz',f1:'ch',t2:'Algerien',f2:'dz',g:'R32',rnd:'Runde der 32',s:'open',s1:'',s2:'',b:'',q1:'',q2:''},
  {id:'R014',d:'04.07.2026',t:'00:00',t1:'Argentinien',f1:'ar',t2:'Kap Verde',f2:'cv',g:'R32',rnd:'Runde der 32',s:'open',s1:'',s2:'',b:'',q1:'',q2:''},
  {id:'R015',d:'04.07.2026',t:'03:30',t1:'Kolumbien',f1:'co',t2:'Ghana',f2:'gh',g:'R32',rnd:'Runde der 32',s:'open',s1:'',s2:'',b:'',q1:'',q2:''},
  {id:'R016',d:'03.07.2026',t:'20:00',t1:'Australien',f1:'au',t2:'Ägypten',f2:'eg',g:'R32',rnd:'Runde der 32',s:'open',s1:'',s2:'',b:'',q1:'',q2:''},
  // ── Achtelfinale ──
  {id:'AF01',d:'04.07.2026',t:'21:00',t1:'Sieger R002',f1:'',t2:'Sieger R005',f2:'',g:'AF',rnd:'Achtelfinale',s:'pending',s1:'',s2:'',b:'pending',q1:'',q2:''},
  {id:'AF02',d:'04.07.2026',t:'18:00',t1:'Kanada',f1:'ca',t2:'Sieger R003',f2:'',g:'AF',rnd:'Achtelfinale',s:'pending',s1:'',s2:'',b:'pending',q1:'',q2:''},
  {id:'AF03',d:'05.07.2026',t:'21:00',t1:'Sieger R004',f1:'',t2:'Sieger R006',f2:'',g:'AF',rnd:'Achtelfinale',s:'pending',s1:'',s2:'',b:'pending',q1:'',q2:''},
  {id:'AF04',d:'05.07.2026',t:'18:00',t1:'Sieger R007',f1:'',t2:'Sieger R008',f2:'',g:'AF',rnd:'Achtelfinale',s:'pending',s1:'',s2:'',b:'pending',q1:'',q2:''},
  {id:'AF05',d:'06.07.2026',t:'21:00',t1:'Sieger R011',f1:'',t2:'Sieger R012',f2:'',g:'AF',rnd:'Achtelfinale',s:'pending',s1:'',s2:'',b:'pending',q1:'',q2:''},
  {id:'AF06',d:'06.07.2026',t:'18:00',t1:'Sieger R009',f1:'',t2:'Sieger R010',f2:'',g:'AF',rnd:'Achtelfinale',s:'pending',s1:'',s2:'',b:'pending',q1:'',q2:''},
  {id:'AF07',d:'07.07.2026',t:'21:00',t1:'Sieger R014',f1:'',t2:'Sieger R016',f2:'',g:'AF',rnd:'Achtelfinale',s:'pending',s1:'',s2:'',b:'pending',q1:'',q2:''},
  {id:'AF08',d:'07.07.2026',t:'18:00',t1:'Sieger R013',f1:'',t2:'Sieger R015',f2:'',g:'AF',rnd:'Achtelfinale',s:'pending',s1:'',s2:'',b:'pending',q1:'',q2:''},
  // ── Viertelfinale ──
  {id:'VF01',d:'09.07.2026',t:'21:00',t1:'Sieger AF01',f1:'',t2:'Sieger AF02',f2:'',g:'VF',rnd:'Viertelfinale',s:'pending',s1:'',s2:'',b:'pending',q1:'',q2:''},
  {id:'VF02',d:'10.07.2026',t:'18:00',t1:'Sieger AF05',f1:'',t2:'Sieger AF06',f2:'',g:'VF',rnd:'Viertelfinale',s:'pending',s1:'',s2:'',b:'pending',q1:'',q2:''},
  {id:'VF03',d:'11.07.2026',t:'21:00',t1:'Sieger AF03',f1:'',t2:'Sieger AF04',f2:'',g:'VF',rnd:'Viertelfinale',s:'pending',s1:'',s2:'',b:'pending',q1:'',q2:''},
  {id:'VF04',d:'11.07.2026',t:'18:00',t1:'Sieger AF07',f1:'',t2:'Sieger AF08',f2:'',g:'VF',rnd:'Viertelfinale',s:'pending',s1:'',s2:'',b:'pending',q1:'',q2:''},
  // ── Halbfinale ──
  {id:'HF01',d:'14.07.2026',t:'21:00',t1:'Sieger VF01',f1:'',t2:'Sieger VF02',f2:'',g:'HF',rnd:'Halbfinale',s:'pending',s1:'',s2:'',b:'🔥 TOP-SPIEL',q1:'',q2:''},
  {id:'HF02',d:'15.07.2026',t:'21:00',t1:'Sieger VF03',f1:'',t2:'Sieger VF04',f2:'',g:'HF',rnd:'Halbfinale',s:'pending',s1:'',s2:'',b:'🔥 TOP-SPIEL',q1:'',q2:''},
  // ── Platz 3 ──
  {id:'P3',d:'18.07.2026',t:'21:00',t1:'Verlierer HF01',f1:'',t2:'Verlierer HF02',f2:'',g:'P3',rnd:'Platz 3',s:'pending',s1:'',s2:'',b:'',q1:'',q2:''},
  // ── Finale ──
  {id:'FIN',d:'19.07.2026',t:'21:00',t1:'Sieger HF01',f1:'',t2:'Sieger HF02',f2:'',g:'FIN',rnd:'Finale',s:'pending',s1:'',s2:'',b:'🏆 WM-FINALE',q1:'',q2:''},
];

// total: 72 Gruppe + 16 Achtelfinale + 8 Viertelfinale + 4 Halbfinale + 2 Platz3 + 2 Finale = 104 ✓

/* ── APP STATE ────────────────────────────────────────────────── */
const state = {
  user:        null,
  tips:        {},      // {gameId: {tipp1, tipp2, tendenz, submitted, points}}
  scores:      {},      // {gameId: {s1, s2, status, minute}} from backend
  activeRound: 'all',
  activeGroup: 'all',
  pageOffset:  0,
  filteredIds: [],
};

/* ── PARTICLES ───────────────────────────────────────────────── */
(function initParticles() {
  const canvas = document.getElementById('particle-canvas');
  if (!canvas) return;
  const ctx = canvas.getContext('2d');
  let W, H, pts = [];
  const COLORS = ['rgba(255,215,0,','rgba(0,255,136,','rgba(0,200,255,','rgba(255,50,100,'];

  const resize = () => { W = canvas.width = innerWidth; H = canvas.height = innerHeight; };
  window.addEventListener('resize', resize); resize();

  function Pt() {
    this.x = Math.random()*W; this.y = Math.random()*H;
    this.r = Math.random()*1.8+.4;
    this.vx = (Math.random()-.5)*.35; this.vy = (Math.random()-.5)*.35;
    this.c = COLORS[Math.floor(Math.random()*COLORS.length)];
    this.a = Math.random()*.35+.08; this.da = (Math.random()-.5)*.004;
  }
  Pt.prototype.draw = function() {
    this.x += this.vx; this.y += this.vy;
    this.a += this.da;
    if (this.a < .06 || this.a > .45) this.da *= -1;
    if (this.x < 0) this.x = W; if (this.x > W) this.x = 0;
    if (this.y < 0) this.y = H; if (this.y > H) this.y = 0;
    ctx.beginPath(); ctx.arc(this.x,this.y,this.r,0,Math.PI*2);
    ctx.fillStyle = this.c + this.a + ')'; ctx.fill();
  };

  for (let i=0;i<100;i++) pts.push(new Pt());
  (function loop() { ctx.clearRect(0,0,W,H); pts.forEach(p=>p.draw()); requestAnimationFrame(loop); })();
})();

/* ── SCROLL TO TOP ───────────────────────────────────────────── */
const scrollTopBtn = document.getElementById('scroll-top');
window.addEventListener('scroll', () => scrollTopBtn.classList.toggle('visible', scrollY > 400));
scrollTopBtn.addEventListener('click', () => scrollTo({top:0,behavior:'smooth'}));

/* ── STREAM COUNTDOWN ────────────────────────────────────────── */
function tickCountdown() {
  const now = new Date();
  const t = new Date(now); t.setHours(18,0,0,0);
  if (now >= t) t.setDate(t.getDate()+1);
  const d = t - now;
  const h = String(Math.floor(d/3600000)).padStart(2,'0');
  const m = String(Math.floor(d%3600000/60000)).padStart(2,'0');
  const s = String(Math.floor(d%60000/1000)).padStart(2,'0');
  const el = document.getElementById('stream-countdown');
  if (el) el.textContent = h+':'+m+':'+s;
  // Progress bar: how far through the day we are (stream is at 18:00)
  const totalMs = 24 * 3600000;
  const bar = document.getElementById('tcd-bar-fill');
  if (bar) {
    const midnight = new Date(now); midnight.setHours(0,0,0,0);
    const pct = Math.min(100, ((now - midnight) / totalMs) * 100);
    bar.style.width = pct + '%';
  }
}
setInterval(tickCountdown,1000); tickCountdown();

/* ── TOAST ───────────────────────────────────────────────────── */
function toast(msg, type='info', ms=4000) {
  const icons = {success:'fa-check-circle', error:'fa-exclamation-circle', info:'fa-info-circle'};
  const el = Object.assign(document.createElement('div'),{className:`wm-toast ${type}`});
  el.innerHTML = `<i class="fas ${icons[type]||icons.info}" style="flex-shrink:0"></i><span>${msg}</span>`;
  document.getElementById('toast-container').appendChild(el);
  setTimeout(()=>{ el.style.opacity='0'; el.style.transition='opacity .3s'; setTimeout(()=>el.remove(),320); }, ms);
}

/* ── TICKER ──────────────────────────────────────────────────── */
function buildTicker() {
  const live = SCHEDULE.filter(g=>g.s==='live'||g.s==='finished').map(g => {
    const pfx = g.s==='live' ? '<span class="tick-live">●</span>' : '';
    const sc  = g.s1!==''&&g.s2!=='' ? `<span class="tick-score">${g.s1}:${g.s2}</span>` : '<span class="tick-score">-:-</span>';
    return `<span class="tick-item">${pfx}${g.t1} ${sc} ${g.t2}</span>`;
  });
  const promos = [
    `<span class="tick-item">⚽ WM 2026 TIPPSPIEL — TÄGLICH <span class="tick-score">18 UHR</span> LIVE AUF TWITCH!</span>`,
    `<span class="tick-item">🏆 Gewinne 1 von 5 exklusiven <span class="tick-score">EVERYBODY IN THE HOUSE</span> WM Shirts</span>`,
    `<span class="tick-item">🔥 <span class="tick-score">104 Spiele</span> tippen — Max. 416 Punkte möglich!</span>`,
    `<span class="tick-item">🎽 Top 5 der Rangliste gewinnen ein <span class="tick-score">Exklusives WM Shirt</span> — Jetzt mitmachen!</span>`,
    `<span class="tick-item"><i class="fab fa-twitch" style="color:#9146FF"></i> Täglich live: <span class="tick-score">twitch.tv/nouri_amk</span></span>`,
  ];
  const el = document.getElementById('ticker-inner');
  if (el) el.innerHTML = [...promos, ...live, ...promos].join('');
}
buildTicker();

/* ── USER ────────────────────────────────────────────────────── */
const WM = {};

WM.changeUser = function() {
  if (!confirm('Benutzerprofil wechseln?')) return;
  state.user = null;
  localStorage.removeItem('wm26_session');
  document.getElementById('auth-wrap')?.classList.remove('wm-hidden');
  document.getElementById('user-portal')?.classList.add('wm-hidden');
  document.getElementById('tippspiel')?.classList.add('wm-hidden');
};

/* ── TIPS PERSISTENCE ────────────────────────────────────────── */
WM.tipsKey = function() {
  if (!state.user) return null;
  return 'wm26_tips_' + btoa(state.user.email).replace(/=/g,'');
};

WM.loadTips = function() {
  const k = WM.tipsKey(); if (!k) return;
  try { state.tips = JSON.parse(localStorage.getItem(k)||'{}'); } catch(e){ state.tips={}; }
};

WM.saveTips = function() {
  const k = WM.tipsKey(); if (!k) return;
  localStorage.setItem(k, JSON.stringify(state.tips));
};

WM.updateMyPts = function() {
  const total = Object.values(state.tips).reduce((s,t)=>s+(t.points||0),0);
  const el = document.getElementById('ub-pts');
  if (el) el.textContent = total;
};

/* ── OPENLIGADB — Normalize team name for matching ───────────── */
function _normName(n) {
  return String(n).toLowerCase()
    .replace(/ä/g,'ae').replace(/ö/g,'oe').replace(/ü/g,'ue').replace(/ß/g,'ss')
    .replace(/[^a-z0-9]/g,'');
}

/* ── FETCH LIVE SCORES FROM OPENLIGADB API ───────────────────── */
// Fetches all group-stage + KO rounds from api.openligadb.de
// Matches by normalized team names to our SCHEDULE array
WM.fetchScores = async function() {
  try {
    // Fetch all rounds in parallel (rounds 1–13 = groups + KO)
    const promises = CFG.OPENLIGA_ROUNDS.map(r =>
      fetch(CFG.OPENLIGA_URL + r)
        .then(res => res.ok ? res.json() : [])
        .catch(() => [])
    );
    const rounds = await Promise.all(promises);
    const allMatches = rounds.flat();

    if (!allMatches.length) return;

    // Build lookup: "normteam1|normteam2" → match object
    const lookup = {};
    for (const m of allMatches) {
      const k = _normName(m.team1?.teamName) + '|' + _normName(m.team2?.teamName);
      lookup[k] = m;
    }

    let changed = false;
    SCHEDULE.forEach(g => {
      if (g.s === 'pending') return;
      const k = _normName(g.t1) + '|' + _normName(g.t2);
      const m = lookup[k];
      if (!m) return;

      // Determine status
      const now = new Date();
      const kickoff = new Date(m.matchDateTime); // local (CEST via timeZoneID)

      // Final result
      if (m.matchIsFinished) {
        const final = (m.matchResults || []).find(r =>
          r.resultName === 'Endergebnis' || r.resultTypeID === 2
        );
        if (final) {
          if (g.s !== 'finished' || g.s1 !== String(final.pointsTeam1) || g.s2 !== String(final.pointsTeam2)) {
            g.s  = 'finished';
            g.s1 = String(final.pointsTeam1);
            g.s2 = String(final.pointsTeam2);
            changed = true;
          }
        }
      }
      // Live: game started but not finished
      else if (now >= kickoff && now < new Date(kickoff.getTime() + 120 * 60000)) {
        if (g.s !== 'live') { g.s = 'live'; changed = true; }
        // Live score from goals array
        const goals = m.goals || [];
        if (goals.length) {
          const last = goals[goals.length - 1];
          g.s1 = String(last.scoreTeam1 ?? '');
          g.s2 = String(last.scoreTeam2 ?? '');
        } else {
          g.s1 = g.s1 || '0';
          g.s2 = g.s2 || '0';
        }
      }
      // Not yet started — lock tipps 5 min before kickoff
      else if (g.s === 'open' && now >= new Date(kickoff.getTime() - 5 * 60000)) {
        g.s = 'locked'; changed = true;
      }
    });

    // K.o.-Bracket auflösen: Sieger automatisch ins Folgespiel eintragen
    if (WM.resolveBracket()) changed = true;

    if (changed) {
      buildTicker();
      WM.applyFilter();
    }

    // ── Google Sheet ist DIE Quelle der Wahrheit ──────────────────
    // Teams, Flaggen, Status, Ergebnisse & Boost aus dem Backend-Sheet
    // übernehmen. Damit erscheinen vom Admin gepflegte/aufgelöste
    // Paarungen (z.B. das Achtelfinale) sofort korrekt und werden tippbar.
    if (!CFG.SCRIPT_URL.includes('DEINE_')) {
      try {
        const r = await fetch(`${CFG.SCRIPT_URL}?action=getScores`);
        const d = await r.json();
        if (d && d.scores && WM.applyBackendGames(d.scores)) {
          buildTicker(); WM.applyFilter();
          if (state.user) WM.loadPortalTips();   // "Meine Tipps" mit echten Teams neu zeichnen
        }
        if (d && d.playerCount) {
          const el = document.getElementById('hs-players');
          if (el) el.textContent = d.playerCount;
        }
      } catch(e) { /* Backend offline → SCHEDULE/OpenLigaDB bleiben */ }
    }

  } catch(e) { console.warn('OpenLigaDB fetch failed:', e.message); }
};

/* ── BACKEND-SPIELE ANWENDEN (Sheet gewinnt) ──────────────────────
   Übernimmt Team-Namen, Flaggen, Status, Ergebnisse & Boost aus dem
   Google Sheet in die SCHEDULE-Liste. So werden im Sheet gepflegte
   K.o.-Paarungen (Achtelfinale etc.) sofort sichtbar und tippbar.
   Gibt true zurück, wenn sich etwas geändert hat.                    */
WM.applyBackendGames = function(scores) {
  let changed = false;
  SCHEDULE.forEach(g => {
    const b = scores[g.id];
    if (!b) return;
    // Nicht-leere Werte übernehmen (Teams/Flaggen)
    const set = (k, v) => {
      if (v === undefined || v === null || v === '') return;
      if (String(g[k]) !== String(v)) { g[k] = String(v); changed = true; }
    };
    set('t1', b.t1); set('f1', b.f1);
    set('t2', b.t2); set('f2', b.f2);
    // Status/Ergebnis/Boost vollständig spiegeln (auch Leerung, z.B.
    // 'pending'-Boost verschwindet, sobald das Spiel geöffnet wird)
    if (b.status && String(g.s) !== String(b.status)) { g.s = String(b.status); changed = true; }
    if (b.s1 !== undefined && String(g.s1||'') !== String(b.s1||'')) { g.s1 = String(b.s1||''); changed = true; }
    if (b.s2 !== undefined && String(g.s2||'') !== String(b.s2||'')) { g.s2 = String(b.s2||''); changed = true; }
    if (b.b  !== undefined && String(g.b ||'') !== String(b.b ||'')) { g.b  = String(b.b ||''); changed = true; }
  });
  return changed;
};

/* ── K.O.-BRACKET AUTO-ZUORDNUNG ──────────────────────────────────
   Sobald ein K.o.-Spiel beendet ist (Ergebnis via OpenLigaDB), wandert
   der Sieger (bzw. beim Spiel um Platz 3 der Verlierer) automatisch mit
   Name + Flagge ins Folgespiel. Stehen beide Teams fest, springt das
   Folgespiel von "pending" auf "open" → Tipps werden möglich.
   type: 'W' = Sieger des Quellspiels, 'L' = Verlierer.            */
const KO_DEP = {
  AF01:[['W','R002'],['W','R005']], AF02:[['W','R001'],['W','R003']],
  AF03:[['W','R004'],['W','R006']], AF04:[['W','R007'],['W','R008']],
  AF05:[['W','R011'],['W','R012']], AF06:[['W','R009'],['W','R010']],
  AF07:[['W','R014'],['W','R016']], AF08:[['W','R013'],['W','R015']],
  VF01:[['W','AF01'],['W','AF02']], VF02:[['W','AF05'],['W','AF06']],
  VF03:[['W','AF03'],['W','AF04']], VF04:[['W','AF07'],['W','AF08']],
  HF01:[['W','VF01'],['W','VF02']], HF02:[['W','VF03'],['W','VF04']],
  P3:  [['L','HF01'],['L','HF02']], FIN: [['W','HF01'],['W','HF02']],
};
const _isPlaceholder = v => /^(Sieger|Verlierer)\s/.test(String(v||''));

WM.resolveBracket = function() {
  const byId = {};
  SCHEDULE.forEach(g => { byId[g.id] = g; });
  let changed = false;

  // In Runden-Reihenfolge, damit Ketten (R32→AF→VF→HF→FIN) in einem Durchlauf greifen
  Object.keys(KO_DEP).forEach(tid => {
    const tgt = byId[tid];
    if (!tgt || tgt.s === 'finished') return;
    const dep = KO_DEP[tid];

    [['t1','f1',dep[0]], ['t2','f2',dep[1]]].forEach(([tk, fk, d]) => {
      if (!_isPlaceholder(tgt[tk])) return;        // Slot schon mit echtem Team gefüllt
      const src = byId[d[1]];
      if (!src || src.s !== 'finished' || src.s1 === '' || src.s2 === '') return;
      const a = parseInt(src.s1), b = parseInt(src.s2);
      if (isNaN(a) || isNaN(b) || a === b) return; // Unentschieden → Elfmeter, manuell
      const t1Wins = a > b;
      const win  = t1Wins ? {n:src.t1, f:src.f1} : {n:src.t2, f:src.f2};
      const lose = t1Wins ? {n:src.t2, f:src.f2} : {n:src.t1, f:src.f1};
      const o = d[0] === 'L' ? lose : win;
      tgt[tk] = o.n; tgt[fk] = o.f || '';
      changed = true;
    });

    // Beide Teams bekannt? → freischalten
    if (!_isPlaceholder(tgt.t1) && !_isPlaceholder(tgt.t2) && tgt.s === 'pending') {
      tgt.s = 'open';
      if (tgt.b === 'pending') tgt.b = '';
      changed = true;
    }
  });
  return changed;
};

/* ── FILTER LOGIC ─────────────────────────────────────────────── */
document.getElementById('round-filter').addEventListener('click', e => {
  const btn = e.target.closest('.fbtn');
  if (!btn) return;
  state.activeRound = btn.dataset.round;
  state.activeGroup = 'all';
  document.querySelectorAll('#round-filter .fbtn').forEach(b=>b.classList.toggle('active',b===btn));
  const gf = document.getElementById('group-filter');
  const showGroups = state.activeRound === 'Gruppenphase';
  gf.classList.toggle('wm-hidden', !showGroups);
  gf.classList.toggle('visible', showGroups);
  document.querySelectorAll('#group-filter .fbtn').forEach(b=>b.classList.toggle('active',b.dataset.group==='all'));
  state.pageOffset = 0;
  WM.applyFilter();
});

document.getElementById('group-filter').addEventListener('click', e => {
  const btn = e.target.closest('.fbtn');
  if (!btn) return;
  state.activeGroup = btn.dataset.group;
  document.querySelectorAll('#group-filter .fbtn').forEach(b=>b.classList.toggle('active',b===btn));
  state.pageOffset = 0;
  WM.applyFilter();
});

// Mappe Round-Button-Label → Funktion die matched
const ROUND_FILTER_MAP = {
  'Gruppenphase':  g => 'ABCDEFGHIJKL'.includes(g.g),
  'Runde der 32':  g => g.g === 'R32',
  'Achtelfinale':  g => g.g === 'AF',
  'Viertelfinale': g => g.g === 'VF',
  'Halbfinale':    g => g.g === 'HF',
  'Finale':        g => g.g === 'FIN' || g.g === 'P3',
};

WM.applyFilter = function() {
  let games = SCHEDULE;

  if (state.activeRound !== 'all') {
    const fn = ROUND_FILTER_MAP[state.activeRound];
    games = fn ? games.filter(fn) : games.filter(g => g.rnd === state.activeRound);
  }

  if (state.activeGroup && state.activeGroup !== 'all') {
    games = games.filter(g => g.g === state.activeGroup);
  }

  state.filteredIds = games.map(g => g.id);
  state.pageOffset  = 0;
  WM.renderGrid(true);
};

/* ── RENDER GRID ──────────────────────────────────────────────── */
WM.renderGrid = function(reset) {
  const grid = document.getElementById('matches-grid');
  if (reset) { grid.innerHTML = ''; }
  const ids   = state.filteredIds;
  const start = reset ? 0 : state.pageOffset;
  const end   = Math.min(start + CFG.PAGE_SIZE, ids.length);
  const chunk = ids.slice(start, end);

  if (ids.length === 0) {
    grid.innerHTML = '<div class="empty-state" style="grid-column:1/-1"><i class="fas fa-calendar-times"></i><p>Keine Spiele für diese Auswahl.</p></div>';
    document.getElementById('load-more-wrap').classList.add('wm-hidden');
    return;
  }

  chunk.forEach(id => {
    const game = SCHEDULE.find(g=>g.id===id);
    if (game) { const el = WM.buildCard(game); grid.appendChild(el); }
  });

  state.pageOffset = end;
  const lmw = document.getElementById('load-more-wrap');
  lmw.classList.toggle('wm-hidden', end >= ids.length);
};

WM.loadMore = function() { WM.renderGrid(false); };

/* ── BUILD MATCH CARD ─────────────────────────────────────────── */
WM.buildCard = function(game) {
  const tip       = state.tips[game.id] || {};
  const isPending = game.s === 'pending';
  const isLocked  = ['locked','live','finished'].includes(game.s);
  const hasResult = game.s === 'finished' && game.s1 !== '' && game.s2 !== '';
  const isLive    = game.s === 'live';

  const div = document.createElement('div');
  div.id = 'card-' + game.id;
  div.className = 'match-card';

  // ── Status bar color ──
  const barCls = isLive ? 'live' : hasResult ? 'done' : isPending ? 'pending' : game.s === 'locked' ? 'done' : 'open';

  // ── Badge ──
  const badgeMap = {
    open:     `<span class="mc-badge open"><i class="fas fa-circle" style="font-size:6px"></i>&nbsp;OFFEN</span>`,
    locked:   `<span class="mc-badge done">GESCHLOSSEN</span>`,
    live:     `<span class="mc-badge live"><i class="fas fa-circle" style="font-size:6px"></i>&nbsp;LIVE</span>`,
    finished: `<span class="mc-badge done"><i class="fas fa-check-circle" style="font-size:9px"></i>&nbsp;BEENDET</span>`,
    pending:  `<span class="mc-badge pending">DEMNÄCHST</span>`,
  };

  // ── Flag ──
  const flag = (code, name) => code
    ? `<img class="mc-flag" src="https://flagcdn.com/48x36/${code}.png" alt="${name}" loading="lazy" onerror="this.style.opacity='.2'">`
    : `<div class="mc-flag" style="background:rgba(255,255,255,.04);display:flex;align-items:center;justify-content:center;font-size:9px;color:var(--dimmed);letter-spacing:.04em">TBD</div>`;

  // ── Center score/VS ──
  let centerHtml = '';
  if (isLive && game.s1 !== '') {
    centerHtml = `<div class="mc-score-live">${game.s1}:${game.s2}</div>`;
    if (game.minute) centerHtml += `<div class="mc-score-min">${game.minute}′</div>`;
  } else if (hasResult) {
    centerHtml = `<div class="mc-score-final">${game.s1}:${game.s2}</div>`;
  } else {
    centerHtml = `<div class="mc-score-vs">VS</div>`;
  }

  // ── Odds ──
  const oddsHtml = (game.q1 && !isPending) ? `
    <div class="mc-odds">
      <span class="mc-odds-val">${game.q1}</span>
      <span class="mc-odds-label">Quote</span>
    </div>` : '';
  const oddsHtml2 = (game.q2 && !isPending) ? `
    <div class="mc-odds">
      <span class="mc-odds-val">${game.q2}</span>
      <span class="mc-odds-label">Quote</span>
    </div>` : '';

  // ── Boost ──
  const boostHtml = game.b
    ? `<div class="mc-boost-badge"><div class="mc-boost-inner"><i class="fas fa-bolt"></i>&nbsp;${game.b}</div></div>`
    : '';

  // ── Tip area ──
  const t1val = tip.tipp1 !== undefined ? tip.tipp1 : 0;
  const t2val = tip.tipp2 !== undefined ? tip.tipp2 : 0;
  let tipHtml = '';

  if (isPending) {
    tipHtml = `<div class="mc-closed-note"><i class="fas fa-lock"></i>&nbsp;Teams noch nicht qualifiziert</div>`;

  } else if (isLocked) {
    if (tip.tipp1 !== undefined) {
      if (hasResult) {
        const pts = tip.points !== undefined ? tip.points
          : calcPoints(tip.tipp1, tip.tipp2, game.s1, game.s2, tip.tendenz).total;
        const msg = pts===4?'🎯 Perfekt! +4 Pkt'
                   :pts===3?'✅ Exakter Score! +3 Pkt'
                   :pts===1?'👍 Richtige Tendenz +1 Pkt'
                           :'❌ Kein Punkt';
        tipHtml = `<div class="mc-pts-display">Tipp: ${tip.tipp1}:${tip.tipp2}&nbsp;·&nbsp;<strong>+${pts} Pkt</strong>&nbsp;&nbsp;${msg}</div>`;
      } else {
        tipHtml = `<div class="mc-closed-note">Dein Tipp: <strong>${tip.tipp1}:${tip.tipp2}</strong>&nbsp;·&nbsp;${tendenzLabel(tip.tendenz)}</div>`;
      }
    } else {
      tipHtml = `<div class="mc-closed-note">Kein Tipp abgegeben</div>`;
    }

  } else {
    // Open game
    const saved = !!tip.submitted;
    tipHtml = `
      <div class="mc-tip-label">DEIN TIPP</div>
      <div class="mc-steppers">
        <div class="stepper-group">
          <button class="step-btn" onclick="WM.step('${game.id}',0,-1)">−</button>
          <span class="step-val" id="sv1-${game.id}">${t1val}</span>
          <button class="step-btn" onclick="WM.step('${game.id}',0,1)">+</button>
        </div>
        <div class="mc-steppers-sep">:</div>
        <div class="stepper-group">
          <button class="step-btn" onclick="WM.step('${game.id}',1,-1)">−</button>
          <span class="step-val" id="sv2-${game.id}">${t2val}</span>
          <button class="step-btn" onclick="WM.step('${game.id}',1,1)">+</button>
        </div>
      </div>
      <div class="tend-row">
        <button class="tend-btn sieg ${tip.tendenz==='sieg'?'active':''}"
          onclick="WM.setTend('${game.id}','sieg')">Sieg</button>
        <button class="tend-btn unent ${tip.tendenz==='unentschieden'?'active':''}"
          onclick="WM.setTend('${game.id}','unentschieden')">Unentsch.</button>
        <button class="tend-btn nied ${tip.tendenz==='niederlage'?'active':''}"
          onclick="WM.setTend('${game.id}','niederlage')">Niederlage</button>
      </div>
      <button class="mc-submit-btn${saved?' saved':''}" id="sub-${game.id}"
        onclick="WM.submitTip('${game.id}')"
        ${(!tip.tendenz && !saved) ? 'disabled' : ''}>
        ${saved
          ? '<i class="fas fa-check"></i>&nbsp;Tipp gespeichert'
          : '<i class="fas fa-paper-plane"></i>&nbsp;Tipp abgeben'}
      </button>`;
  }

  div.innerHTML = `
    <div class="mc-status-bar ${barCls}"></div>
    <div class="mc-head">
      <span class="mc-meta">${game.rnd}&nbsp;·&nbsp;${game.d}&nbsp;${game.t}</span>
      ${badgeMap[game.s] || ''}
    </div>
    <div class="mc-teams">
      <div class="mc-team">
        ${flag(game.f1, game.t1)}
        <div class="mc-team-name${isPending?' mc-pending-name':''}">${game.t1}</div>
        ${oddsHtml}
      </div>
      <div class="mc-score-display">${centerHtml}</div>
      <div class="mc-team">
        ${flag(game.f2, game.t2)}
        <div class="mc-team-name${isPending?' mc-pending-name':''}">${game.t2}</div>
        ${oddsHtml2}
      </div>
    </div>
    ${boostHtml}
    <div class="mc-tip-area">${tipHtml}</div>`;

  return div;
};

/* ── STEPPER ──────────────────────────────────────────────────── */
WM.step = function(id, team, delta) {
  if (!state.tips[id]) state.tips[id] = {tipp1:0,tipp2:0,tendenz:''};
  const key = team===0 ? 'tipp1':'tipp2';
  state.tips[id][key] = Math.max(0, Math.min(20, (state.tips[id][key]||0)+delta));
  const el = document.getElementById(team===0?`sv1-${id}`:`sv2-${id}`);
  if (el) el.textContent = state.tips[id][key];
  // Auto-suggest tendency from score
  const t = state.tips[id];
  const auto = t.tipp1>t.tipp2?'sieg':t.tipp1===t.tipp2?'unentschieden':'niederlage';
  WM.setTend(id, auto, true);
  WM.saveTips();
};

/* ── TENDENCY ─────────────────────────────────────────────────── */
WM.setTend = function(id, val, silent=false) {
  if (!state.tips[id]) state.tips[id] = {tipp1:0,tipp2:0,tendenz:''};
  state.tips[id].tendenz = val;
  const card = document.getElementById('card-'+id);
  if (card) {
    // class mapping: sieg→.sieg, unentschieden→.unent, niederlage→.nied
    const map = {sieg:'sieg', unentschieden:'unent', niederlage:'nied'};
    card.querySelectorAll('.tend-btn').forEach(b => {
      const isActive = b.classList.contains(map[val]);
      b.classList.toggle('active', isActive);
    });
  }
  const sub = document.getElementById('sub-'+id);
  if (sub) sub.disabled = false;
  if (!silent) WM.saveTips();
};

/* ── SUBMIT TIP ───────────────────────────────────────────────── */
WM.submitTip = async function(id) {
  if (!state.user) { toast('Bitte zuerst registrieren!','error'); return; }
  const tip = state.tips[id];
  if (!tip||!tip.tendenz) { toast('Bitte Tendenz auswählen!','error'); return; }

  const btn = document.getElementById('sub-'+id);
  if (btn) { btn.disabled=true; btn.innerHTML='<i class="fas fa-spinner fa-spin"></i> Sende…'; }

  try {
    // Spiel-Metadaten mitschicken: falls das Spiel im Backend-Sheet noch
    // fehlt (z.B. neu freigeschaltetes K.o.-Spiel), legt das Backend es
    // daraus selbst an — so gibt es nie "Spiel nicht gefunden".
    const g = SCHEDULE.find(x => x.id === id) || {};
    const payload = {
      action:'submitTip', name:state.user.name, email:state.user.email,
      spielId:id, tipp1:tip.tipp1||0, tipp2:tip.tipp2||0, tendenz:tip.tendenz,
      game:{ d:g.d, t:g.t, t1:g.t1, f1:g.f1, t2:g.t2, f2:g.f2, b:g.b, q1:g.q1, q2:g.q2 }
    };
    let ok = true;
    if (!CFG.SCRIPT_URL.includes('DEINE_')) {
      const res = await fetch(CFG.SCRIPT_URL,{
        method:'POST',headers:{'Content-Type':'text/plain'},body:JSON.stringify(payload)
      });
      const data = await res.json();
      if (!data.success) { toast(data.message||'Fehler beim Speichern.','error'); ok=false; }
    }
    if (ok) {
      state.tips[id].submitted = true;
      WM.saveTips();
      toast('Tipp gespeichert! 🎯','success');
      if (btn) {
        btn.classList.add('saved');
        btn.innerHTML = '<i class="fas fa-check"></i>&nbsp;Tipp gespeichert';
        btn.disabled = false;
      }
    } else {
      if (btn) { btn.disabled=false; btn.innerHTML='<i class="fas fa-paper-plane"></i>&nbsp;Tipp abgeben'; }
    }
  } catch(e) {
    toast('Verbindungsfehler. Nochmal versuchen.','error');
    if (btn) { btn.disabled=false; btn.innerHTML='<i class="fas fa-paper-plane"></i>&nbsp;Tipp abgeben'; }
  }
};

/* ── LEADERBOARD ──────────────────────────────────────────────── */
WM.loadLB = async function() {
  const el = document.getElementById('lb-table');
  try {
    if (CFG.SCRIPT_URL.includes('DEINE_')) {
      // Demo leaderboard from local tips
      const demo = [{name:'Max Mustermann',email:'max@demo.de',punkte:38,exakt:8},
                    {name:'Julia Koch',    email:'j@demo.de',  punkte:31,exakt:6},
                    {name:'Tom Bauer',     email:'t@demo.de',  punkte:28,exakt:5}];
      return WM.renderLB(demo);
    }
    const res  = await fetch(`${CFG.SCRIPT_URL}?action=getLeaderboard`);
    const data = await res.json();
    WM.renderLB(data.leaderboard||[]);
    if (data.playerCount) {
      const pe = document.getElementById('hs-players');
      if (pe) pe.textContent = data.playerCount;
    }
  } catch(e) { el.innerHTML='<div class="empty-state"><i class="fas fa-trophy"></i><p>Rangliste wird geladen…</p></div>'; }
};

WM.renderLB = function(rows) {
  const myEmail = state.user?.email || '';
  const trophy  = ['🥇','🥈','🥉'];
  if (!rows.length) {
    document.getElementById('lb-table').innerHTML =
      `<div class="loading-spinner" style="padding:32px">
         <i class="fas fa-trophy" style="color:var(--gold);font-size:28px;display:block;text-align:center;margin-bottom:14px"></i>
         <p>Noch keine Tipps abgegeben</p>
       </div>`;
    return;
  }
  const html = rows.slice(0,10).map((r,i) => {
    const pos = i + 1, isMe = r.email === myEmail;
    const rankCls = pos===1?'top1':pos===2?'top2':pos===3?'top3':'';
    const label   = pos<=3 ? trophy[pos-1] : `#${pos}`;
    return `<div class="lb-row${isMe?' me':''}">
      <div class="lb-rank ${rankCls}">${label}</div>
      <div>
        <div class="lb-name">${esc(r.name)}${isMe?'&nbsp;<small style="color:var(--gold);font-size:10px;font-family:Inter,sans-serif">📍 Du</small>':''}</div>
        <div class="lb-tips">${r.exakt||0}× exakt getippt</div>
      </div>
      <div class="lb-trophy">${pos<=3?'🏆':''}</div>
      <div class="lb-pts">${r.punkte||0}</div>
    </div>`;
  }).join('');
  document.getElementById('lb-table').innerHTML = html;
};

/* ── HELPERS ──────────────────────────────────────────────────── */
function calcPoints(t1,t2,s1,s2,tend) {
  const n1=parseInt(s1),n2=parseInt(s2),u1=parseInt(t1),u2=parseInt(t2);
  if (isNaN(n1)||isNaN(n2)) return {score:0,tendency:0,total:0};
  const pScore = (u1===n1&&u2===n2) ? CFG.PTS_EXACT : 0;
  const real   = n1>n2?'sieg':n1===n2?'unentschieden':'niederlage';
  const pTend  = tend===real ? CFG.PTS_TEND : 0;
  return {score:pScore, tendency:pTend, total:pScore+pTend};
}

function tendenzLabel(t) {
  return {sieg:'Sieg',unentschieden:'Unentschieden',niederlage:'Niederlage'}[t]||'–';
}

function esc(str) {
  const d=document.createElement('div'); d.textContent=str||''; return d.innerHTML;
}

/* ══════════════════════════════════════════
   AUTH — Register / Login / Logout
   ══════════════════════════════════════════ */

// Simple SHA-256 for demo mode password hashing
async function simpleHash(str) {
  const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(str));
  return Array.from(new Uint8Array(buf)).map(b=>b.toString(16).padStart(2,'0')).join('');
}

WM.authTab = function(tab) {
  ['login','register'].forEach(t => {
    document.getElementById('atab-'+t)?.classList.toggle('active', t===tab);
    document.getElementById('auth-'+t)?.classList.toggle('wm-hidden', t!==tab);
  });
};

WM.togglePw = function(id) {
  const el = document.getElementById(id);
  if (el) el.type = el.type==='password' ? 'text' : 'password';
};

WM.register = async function() {
  const name  = document.getElementById('reg-name')?.value.trim() || '';
  const email = document.getElementById('reg-email')?.value.trim().toLowerCase() || '';
  const pw    = document.getElementById('reg-pw')?.value || '';
  const pw2   = document.getElementById('reg-pw2')?.value || '';
  if (name.length < 2)       { toast('Bitte gib deinen Namen ein.','error'); return; }
  if (!email.includes('@'))  { toast('Bitte gib eine gültige E-Mail ein.','error'); return; }
  if (pw.length < 6)         { toast('Passwort mindestens 6 Zeichen.','error'); return; }
  if (pw !== pw2)            { toast('Passwörter stimmen nicht überein.','error'); return; }

  const btn = document.getElementById('btn-register');
  if (btn) { btn.disabled=true; btn.innerHTML='<i class="fas fa-spinner fa-spin"></i> Registriere…'; }

  try {
    const pwHash = await simpleHash(pw + email);

    if (!CFG.SCRIPT_URL.includes('DEINE_')) {
      const res  = await fetch(CFG.SCRIPT_URL,{method:'POST',headers:{'Content-Type':'text/plain'},
        body:JSON.stringify({action:'register',name,email,pwHash})});
      const data = await res.json();
      if (!data.success) {
        toast(data.message||'Registrierung fehlgeschlagen.','error');
        if (btn) { btn.disabled=false; btn.innerHTML='<i class="fas fa-rocket"></i> Jetzt registrieren'; }
        return;
      }
      WM._setSession(data.token, name, email);
    } else {
      // Demo mode — localStorage only
      const users = JSON.parse(localStorage.getItem('wm26_users')||'[]');
      if (users.find(u=>u.email===email)) {
        toast('E-Mail bereits registriert. Bitte anmelden.','error');
        if (btn) { btn.disabled=false; btn.innerHTML='<i class="fas fa-rocket"></i> Jetzt registrieren'; }
        return;
      }
      users.push({name,email,pwHash,ts:Date.now()});
      localStorage.setItem('wm26_users', JSON.stringify(users));
      WM._setSession('demo_'+Math.random().toString(36).slice(2), name, email);
    }
    toast(`Willkommen, ${name}! Viel Erfolg! 🏆`,'success');
    WM.showTipSection();
    setTimeout(()=>document.getElementById('tippspiel')?.scrollIntoView({behavior:'smooth'}),500);
  } catch(e) {
    toast('Fehler bei der Registrierung.','error');
    if (btn) { btn.disabled=false; btn.innerHTML='<i class="fas fa-rocket"></i> Jetzt registrieren'; }
  }
};

WM.login = async function() {
  const email = document.getElementById('login-email')?.value.trim().toLowerCase() || '';
  const pw    = document.getElementById('login-pw')?.value || '';
  if (!email.includes('@')) { toast('Bitte gib deine E-Mail ein.','error'); return; }
  if (!pw)                  { toast('Bitte gib dein Passwort ein.','error'); return; }

  const btn = document.getElementById('btn-login');
  if (btn) { btn.disabled=true; btn.innerHTML='<i class="fas fa-spinner fa-spin"></i> Anmelde…'; }

  try {
    const pwHash = await simpleHash(pw + email);

    if (!CFG.SCRIPT_URL.includes('DEINE_')) {
      const res  = await fetch(CFG.SCRIPT_URL,{method:'POST',headers:{'Content-Type':'text/plain'},
        body:JSON.stringify({action:'login',email,pwHash})});
      const data = await res.json();
      if (!data.success) {
        toast(data.message||'Anmeldung fehlgeschlagen.','error');
        if (btn) { btn.disabled=false; btn.innerHTML='<i class="fas fa-sign-in-alt"></i> Anmelden'; }
        return;
      }
      WM._setSession(data.token, data.name, email);
    } else {
      const users  = JSON.parse(localStorage.getItem('wm26_users')||'[]');
      const user   = users.find(u=>u.email===email && u.pwHash===pwHash);
      if (!user) {
        toast('E-Mail oder Passwort falsch.','error');
        if (btn) { btn.disabled=false; btn.innerHTML='<i class="fas fa-sign-in-alt"></i> Anmelden'; }
        return;
      }
      WM._setSession('demo_'+Math.random().toString(36).slice(2), user.name, email);
    }
    toast('Erfolgreich angemeldet! 👋','success');
    WM.showTipSection();
  } catch(e) {
    toast('Verbindungsfehler.','error');
    if (btn) { btn.disabled=false; btn.innerHTML='<i class="fas fa-sign-in-alt"></i> Anmelden'; }
  }
};

WM._setSession = function(token, name, email) {
  state.user = {name, email, token};
  localStorage.setItem('wm26_session', JSON.stringify({token,name,email,expires:Date.now()+30*24*3600*1000}));
  WM.loadTips();
};

WM.logout = function() {
  if (!confirm('Wirklich abmelden?')) return;
  if (state.user?.token && !CFG.SCRIPT_URL.includes('DEINE_')) {
    fetch(CFG.SCRIPT_URL,{method:'POST',headers:{'Content-Type':'text/plain'},
      body:JSON.stringify({action:'logout',token:state.user.token})}).catch(()=>{});
  }
  state.user = null;
  localStorage.removeItem('wm26_session');
  document.getElementById('auth-wrap')?.classList.remove('wm-hidden');
  document.getElementById('user-portal')?.classList.add('wm-hidden');
  document.getElementById('tippspiel')?.classList.add('wm-hidden');
  toast('Erfolgreich abgemeldet.','info',3000);
};

WM.loadUser = function() {
  try {
    const sess = JSON.parse(localStorage.getItem('wm26_session')||'null');
    if (sess && sess.expires > Date.now()) {
      state.user = {name:sess.name, email:sess.email, token:sess.token};
    }
  } catch(e) {}
  WM.loadTips();
  if (state.user) WM.showTipSection();
};

WM.showTipSection = function() {
  document.getElementById('auth-wrap')?.classList.add('wm-hidden');
  document.getElementById('user-portal')?.classList.remove('wm-hidden');
  document.getElementById('tippspiel')?.classList.remove('wm-hidden');
  // user bar in tipping section
  const ub = document.getElementById('user-bar');
  if (ub) { ub.classList.remove('wm-hidden'); }
  if (document.getElementById('ub-name'))  document.getElementById('ub-name').textContent  = state.user.name;
  if (document.getElementById('ub-email')) document.getElementById('ub-email').textContent = state.user.email;
  // portal header
  if (document.getElementById('pp-name'))  document.getElementById('pp-name').textContent  = state.user.name;
  if (document.getElementById('pp-email')) document.getElementById('pp-email').textContent = state.user.email;

  WM.fetchScores();
  WM.applyFilter();
  WM.updateMyPts();
  WM.loadPortalTips();

  // Validate session in background
  if (!CFG.SCRIPT_URL.includes('DEINE_')) WM._validateSession();
};

WM._validateSession = async function() {
  if (!state.user?.token) return;
  try {
    const res  = await fetch(`${CFG.SCRIPT_URL}?action=validateSession&token=${encodeURIComponent(state.user.token)}`);
    const data = await res.json();
    if (!data.valid) {
      state.user = null; localStorage.removeItem('wm26_session');
      document.getElementById('auth-wrap')?.classList.remove('wm-hidden');
      document.getElementById('user-portal')?.classList.add('wm-hidden');
      document.getElementById('tippspiel')?.classList.add('wm-hidden');
      toast('Sitzung abgelaufen. Bitte neu anmelden.','info');
    } else {
      if (data.rank)  document.getElementById('pp-rank')?.setAttribute('data-val','#'+data.rank);
      if (data.rank)  document.getElementById('pp-rank') && (document.getElementById('pp-rank').textContent='#'+data.rank);
      if (data.punkte!==undefined) document.getElementById('pp-pts') && (document.getElementById('pp-pts').textContent=data.punkte);
    }
  } catch(e) {}
};

/* ══════════════════════════════════════════
   USER PORTAL
   ══════════════════════════════════════════ */

WM.portalTab = function(tab) {
  document.querySelectorAll('.ptab').forEach(b=>b.classList.toggle('active',b.dataset.tab===tab));
  document.getElementById('ptab-tipps')?.classList.toggle('wm-hidden', tab!=='tipps');
  document.getElementById('ptab-board')?.classList.toggle('wm-hidden', tab!=='board');
  if (tab==='board') WM.loadPortalLB();
};

WM.loadPortalTips = function() {
  const container = document.getElementById('portal-tips-list');
  if (!container) return;
  const tipEntries = Object.entries(state.tips).filter(([,t])=>t.tipp1!==undefined);
  if (!tipEntries.length) {
    container.innerHTML=`<div class="empty-portal"><i class="fas fa-crosshairs"></i><p>Noch keine Tipps abgegeben.<br>Scrolle zu den Spielen und tippe!</p><a href="#tippspiel" class="btn btn-primary" style="margin-top:12px"><i class="fas fa-crosshairs"></i> Zu den Spielen</a></div>`;
    return;
  }
  // Group by round
  const byRound = {};
  let totalPts=0, totalTips=0, totalExact=0;
  tipEntries.forEach(([id,tip])=>{
    const game = SCHEDULE.find(g=>g.id===id);
    if (!game) return;
    if (!byRound[game.rnd]) byRound[game.rnd]=[];
    byRound[game.rnd].push({game,tip});
    totalTips++;
    if (game.s==='finished'&&game.s1!=='') {
      const r = calcPoints(tip.tipp1,tip.tipp2,game.s1,game.s2,tip.tendenz);
      totalPts += r.total;
      if (r.score>0) totalExact++;
    }
  });
  // Update portal header
  if (document.getElementById('pp-pts'))      document.getElementById('pp-pts').textContent = totalPts;
  if (document.getElementById('pp-tips-n'))   document.getElementById('pp-tips-n').textContent = totalTips;
  if (document.getElementById('pp-exact-n'))  document.getElementById('pp-exact-n').textContent = totalExact;
  WM.updateMyPts();

  let html = '';
  Object.entries(byRound).forEach(([rnd,items])=>{
    html+=`<div class="ptips-round"><div class="ptips-round-label">${rnd}</div>`;
    items.forEach(({game,tip})=>{
      const done = game.s==='finished'&&game.s1!=='';
      let pts=0, medal='';
      if (done&&tip.tipp1!==undefined) {
        const r=calcPoints(tip.tipp1,tip.tipp2,game.s1,game.s2,tip.tendenz);
        pts=r.total;
        medal=pts===4?'🎯':pts===3?'✅':pts===1?'👍':'❌';
      }
      const f1=game.f1?`<img src="https://flagcdn.com/24x18/${game.f1}.png" alt="${game.t1}" style="border-radius:2px">`:' ';
      const f2=game.f2?`<img src="https://flagcdn.com/24x18/${game.f2}.png" alt="${game.t2}" style="border-radius:2px">`:' ';
      const result=done?`${game.s1}:${game.s2}`:'–';
      html+=`<div class="ptips-row">
        <div class="ptips-teams">${f1}${game.t1}<span class="ptips-vs">vs</span>${f2}${game.t2}</div>
        <div class="ptips-tip">${tip.tipp1}:${tip.tipp2}</div>
        <div class="ptips-result">${result}</div>
        <div class="ptips-pts${done&&pts>0?' positive':''}">${done?medal+' +'+pts+' Pkt':'Offen'}</div>
      </div>`;
    });
    html+='</div>';
  });
  container.innerHTML=html;
};

WM.loadPortalLB = async function() {
  const el=document.getElementById('portal-lb');
  if (!el) return;
  try {
    if (CFG.SCRIPT_URL.includes('DEINE_')) {
      return WM._renderPortalLB(el,[
        {name:'Max Mustermann',email:'max@demo.de',punkte:38,exakt:8},
        {name:'Julia Koch',email:'j@demo.de',punkte:31,exakt:6},
        {name:'Tom Bauer',email:'t@demo.de',punkte:28,exakt:5},
      ]);
    }
    const res=await fetch(`${CFG.SCRIPT_URL}?action=getLeaderboard`);
    const data=await res.json();
    WM._renderPortalLB(el,(data.leaderboard||[]).slice(0,10));
  } catch(e){ el.innerHTML='<div class="loading-spinner"><p>Fehler beim Laden.</p></div>'; }
};

WM._renderPortalLB = function(el,rows) {
  const myEmail=state.user?.email||'';
  const trophy=['🥇','🥈','🥉'];
  const html=rows.slice(0,10).map((r,i)=>{
    const pos=i+1,isMe=r.email===myEmail;
    const rankCls=pos===1?'top1':pos===2?'top2':pos===3?'top3':'';
    return `<div class="lb-row${isMe?' me':''}">
      <div class="lb-rank ${rankCls}">${pos<=3?trophy[pos-1]:'#'+pos}</div>
      <div><div class="lb-name">${esc(r.name)}${isMe?'&nbsp;<small style="color:var(--gold);font-size:10px">📍 Du</small>':''}</div>
      <div class="lb-tips">${r.exakt||0}× exakt</div></div>
      <div class="lb-trophy">${pos<=3?'🏆':''}</div>
      <div class="lb-pts">${r.punkte||0}</div>
    </div>`;
  }).join('');
  el.innerHTML=html||'<div class="loading-spinner"><p>Noch keine Einträge</p></div>';
};

/* ── JETZT TIPPEN — scrollt zu Auth wenn nicht eingeloggt ───── */
WM.goTippen = function() {
  if (state.user) {
    document.getElementById('tippspiel')?.scrollIntoView({behavior:'smooth'});
  } else {
    document.getElementById('registrieren')?.scrollIntoView({behavior:'smooth'});
    // switch to register tab for new visitors
    setTimeout(() => WM.authTab('register'), 400);
  }
};

/* ── LIVE LEADERBOARD (Twitch Section) ──────────────────────── */
WM.renderLiveLB = function(rows) {
  const el = document.getElementById('live-lb-table');
  if (!el) return;
  if (!rows || !rows.length) {
    el.innerHTML = '<div class="llb-loading">Noch keine Einträge — sei der Erste!</div>';
    return;
  }
  const medals = ['🥇','🥈','🥉'];
  const posClass = ['gold','silver','bronze'];
  el.innerHTML = rows.slice(0,10).map((r,i) => {
    const pos = i + 1;
    const pc  = posClass[i] || '';
    const rc  = i < 3 ? `top${pos}` : '';
    return `<div class="llb-row ${rc}">
      <div class="llb-pos ${pc}">${medals[i] || '#'+pos}</div>
      <div>
        <div class="llb-name">${r.name || r.email || '–'}</div>
        <div class="llb-exakt">${r.exakt||0}× exakt · ${r.tips||0} Tipps</div>
      </div>
      <div class="llb-pts">${r.punkte||0} Pkt</div>
    </div>`;
  }).join('');
};

WM.loadLiveLB = async function() {
  const el = document.getElementById('live-lb-table');
  if (!el) return;

  if (CFG.SCRIPT_URL.includes('DEINE_')) {
    // Demo mode: use local tips
    const byUser = {};
    Object.values(state.tips).forEach(t => {
      const em = t.email || 'demo';
      if (!byUser[em]) byUser[em] = {name: t.name||em, email:em, punkte:0, exakt:0, tips:0};
      byUser[em].punkte += t.points||0;
      if ((t.points||0) >= CFG.PTS_EXACT) byUser[em].exakt++;
      byUser[em].tips++;
    });
    const rows = Object.values(byUser).sort((a,b)=>b.punkte-a.punkte);
    WM.renderLiveLB(rows);
    return;
  }
  try {
    const res  = await fetch(`${CFG.SCRIPT_URL}?action=getLeaderboard`);
    const data = await res.json();
    if (data.leaderboard) WM.renderLiveLB(data.leaderboard);
  } catch(e) { console.warn('LiveLB fetch failed'); }
};

/* ── INIT ────────────────────────────────────────────────────── */
WM.loadUser();
WM.loadLB();       // Portal-LB
WM.loadLiveLB();   // Twitch-section Live-LB
WM.resolveBracket();                    // K.o.-Bracket aus vorhandenen Ergebnissen auflösen
WM.fetchScores();                       // sofort beim Laden (OpenLigaDB)
setInterval(WM.fetchScores, 30000);     // alle 30 Sek. OpenLigaDB pollen
setInterval(WM.loadLB, 60000);          // Leaderboard alle 60 Sek.
setInterval(WM.loadLiveLB, 60000);      // Live-LB alle 60 Sek.

if (CFG.SCRIPT_URL.includes('DEINE_')) {
  toast('Demo-Modus aktiv — Apps Script URL noch nicht eingetragen','info',8000);
}